// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Support Chat Panel
   Positioned next to the sidebar, draggable & resizable
   =================================== */

@keyframes chat-panel-enter {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes chat-dot-pulse {
  0%, 80%, 100% {
    transform: scale(0.65);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.support-chat {
  position: fixed;
  display: flex;
  flex-direction: column;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.07);
  z-index: 200;
  overflow: hidden;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  animation: chat-panel-enter 0.2s ease forwards;
}

.support-chat--minimized {
  /* height is auto in minimized state */
}

/* ===================================
   Header (drag handle)
   =================================== */

.support-chat__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
  cursor: grab;
  background: var(--color-bg-sidebar);
  gap: 8px;
}

.support-chat--minimized .support-chat__header {
  border-bottom: none;
}

.support-chat--dragging .support-chat__header,
.support-chat__header:active {
  cursor: grabbing;
}

.support-chat__header-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
}

.support-chat__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.18);
}

.support-chat__header-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.support-chat__header-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.support-chat__header-subtitle {
  font-size: 11px;
  color: var(--color-text-secondary);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.support-chat__header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.support-chat__icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}

.support-chat__icon-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.support-chat__icon-btn--close:hover {
  background: var(--color-status-error-tint);
  color: var(--color-status-error-text);
}

/* ===================================
   Messages area
   =================================== */

.support-chat__messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
}

.support-chat__messages::-webkit-scrollbar {
  width: 4px;
}

.support-chat__messages::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar-thumb);
  border-radius: 2px;
}

.support-chat__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  color: var(--color-text-secondary);
  padding: 24px 8px;
}

.support-chat__loading-dots {
  display: flex;
  gap: 3px;
}

.support-chat__loading-dots span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--color-text-secondary);
  animation: chat-dot-pulse 1.2s ease-in-out infinite;
}

.support-chat__loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.support-chat__loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.support-chat__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary);
  text-align: center;
  padding: 32px 20px;
}

.support-chat__empty svg {
  opacity: 0.35;
}

.support-chat__empty p {
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
  max-width: 200px;
}

/* ===================================
   Individual messages
   =================================== */

.support-chat__message {
  display: flex;
}

.support-chat__message--user {
  justify-content: flex-end;
}

.support-chat__message--support {
  justify-content: flex-start;
}

.support-chat__bubble {
  max-width: 82%;
  padding: 7px 11px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.55;
  word-break: break-word;
  white-space: pre-wrap;
  -webkit-user-select: text;
          user-select: text;
}

.support-chat__message--user .support-chat__bubble {
  background: var(--color-accent-base);
  color: #ffffff;
  border-bottom-right-radius: 3px;
}

.support-chat__message--support .support-chat__bubble {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
  border-bottom-left-radius: 3px;
}

/* ===================================
   Input area
   =================================== */

.support-chat__input-area {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 8px 10px;
  border-top: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.support-chat__textarea {
  flex: 1 1;
  resize: none;
  border: 1px solid var(--color-border-input);
  border-radius: 7px;
  padding: 7px 10px;
  font-size: 12px;
  font-family: inherit;
  background: var(--color-bg-canvas);
  color: var(--color-text-primary);
  outline: none;
  line-height: 1.5;
  min-height: 34px;
  max-height: 90px;
  overflow-y: auto;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  -webkit-user-select: text;
          user-select: text;
}

.support-chat__textarea::placeholder {
  color: var(--color-text-secondary);
}

.support-chat__textarea:focus {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 2px var(--color-focus-ring);
}

.support-chat__textarea:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.support-chat__send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 7px;
  background: var(--color-accent-base);
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease, box-shadow 0.15s ease;
}

.support-chat__send-btn:hover:not(:disabled) {
  opacity: 0.88;
  box-shadow: var(--color-shadow-send-hover);
}

.support-chat__send-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ===================================
   Resize handles
   =================================== */

.support-chat__resize-handle {
  position: absolute;
  z-index: 10;
}

.support-chat__resize-handle--e {
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
}

.support-chat__resize-handle--s {
  bottom: 0;
  left: 0;
  height: 6px;
  width: calc(100% - 12px);
  cursor: ns-resize;
}

.support-chat__resize-handle--se {
  bottom: 0;
  right: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
}

/* Subtle corner indicator for SE resize */
.support-chat__resize-handle--se::after {
  content: '';
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-right: 1.5px solid var(--color-text-secondary);
  border-bottom: 1.5px solid var(--color-text-secondary);
  opacity: 0.35;
  border-radius: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportChat.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,yEAAyE;EACzE,YAAY;EACZ,gBAAgB;EAChB,kEAAkE;EAClE,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;wCAEwC;;AAExC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;EAC1D,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;wCAEwC;;AAExC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,qDAAqD;EACrD,sDAAsD;EACtD,aAAa;EACb,kBAAkB;AACpB","sourcesContent":["/* ===================================\n   Support Chat Panel\n   Positioned next to the sidebar, draggable & resizable\n   =================================== */\n\n@keyframes chat-panel-enter {\n  from {\n    opacity: 0;\n    transform: translateY(6px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes chat-dot-pulse {\n  0%, 80%, 100% {\n    transform: scale(0.65);\n    opacity: 0.4;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.support-chat {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.07);\n  z-index: 200;\n  overflow: hidden;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  animation: chat-panel-enter 0.2s ease forwards;\n}\n\n.support-chat--minimized {\n  /* height is auto in minimized state */\n}\n\n/* ===================================\n   Header (drag handle)\n   =================================== */\n\n.support-chat__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n  cursor: grab;\n  background: var(--color-bg-sidebar);\n  gap: 8px;\n}\n\n.support-chat--minimized .support-chat__header {\n  border-bottom: none;\n}\n\n.support-chat--dragging .support-chat__header,\n.support-chat__header:active {\n  cursor: grabbing;\n}\n\n.support-chat__header-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n}\n\n.support-chat__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #22c55e;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.18);\n}\n\n.support-chat__header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.support-chat__header-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.support-chat__header-subtitle {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.support-chat__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.support-chat__icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.15s ease, color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.support-chat__icon-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.support-chat__icon-btn--close:hover {\n  background: var(--color-status-error-tint);\n  color: var(--color-status-error-text);\n}\n\n/* ===================================\n   Messages area\n   =================================== */\n\n.support-chat__messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 0;\n}\n\n.support-chat__messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.support-chat__messages::-webkit-scrollbar-thumb {\n  background: var(--color-scrollbar-thumb);\n  border-radius: 2px;\n}\n\n.support-chat__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  padding: 24px 8px;\n}\n\n.support-chat__loading-dots {\n  display: flex;\n  gap: 3px;\n}\n\n.support-chat__loading-dots span {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--color-text-secondary);\n  animation: chat-dot-pulse 1.2s ease-in-out infinite;\n}\n\n.support-chat__loading-dots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.support-chat__loading-dots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.support-chat__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary);\n  text-align: center;\n  padding: 32px 20px;\n}\n\n.support-chat__empty svg {\n  opacity: 0.35;\n}\n\n.support-chat__empty p {\n  font-size: 12px;\n  line-height: 1.6;\n  margin: 0;\n  max-width: 200px;\n}\n\n/* ===================================\n   Individual messages\n   =================================== */\n\n.support-chat__message {\n  display: flex;\n}\n\n.support-chat__message--user {\n  justify-content: flex-end;\n}\n\n.support-chat__message--support {\n  justify-content: flex-start;\n}\n\n.support-chat__bubble {\n  max-width: 82%;\n  padding: 7px 11px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.55;\n  word-break: break-word;\n  white-space: pre-wrap;\n  user-select: text;\n}\n\n.support-chat__message--user .support-chat__bubble {\n  background: var(--color-accent-base);\n  color: #ffffff;\n  border-bottom-right-radius: 3px;\n}\n\n.support-chat__message--support .support-chat__bubble {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n  border-bottom-left-radius: 3px;\n}\n\n/* ===================================\n   Input area\n   =================================== */\n\n.support-chat__input-area {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  padding: 8px 10px;\n  border-top: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.support-chat__textarea {\n  flex: 1;\n  resize: none;\n  border: 1px solid var(--color-border-input);\n  border-radius: 7px;\n  padding: 7px 10px;\n  font-size: 12px;\n  font-family: inherit;\n  background: var(--color-bg-canvas);\n  color: var(--color-text-primary);\n  outline: none;\n  line-height: 1.5;\n  min-height: 34px;\n  max-height: 90px;\n  overflow-y: auto;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  user-select: text;\n}\n\n.support-chat__textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.support-chat__textarea:focus {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 2px var(--color-focus-ring);\n}\n\n.support-chat__textarea:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.support-chat__send-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 7px;\n  background: var(--color-accent-base);\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: opacity 0.15s ease, box-shadow 0.15s ease;\n}\n\n.support-chat__send-btn:hover:not(:disabled) {\n  opacity: 0.88;\n  box-shadow: var(--color-shadow-send-hover);\n}\n\n.support-chat__send-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* ===================================\n   Resize handles\n   =================================== */\n\n.support-chat__resize-handle {\n  position: absolute;\n  z-index: 10;\n}\n\n.support-chat__resize-handle--e {\n  top: 0;\n  right: 0;\n  width: 6px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n.support-chat__resize-handle--s {\n  bottom: 0;\n  left: 0;\n  height: 6px;\n  width: calc(100% - 12px);\n  cursor: ns-resize;\n}\n\n.support-chat__resize-handle--se {\n  bottom: 0;\n  right: 0;\n  width: 14px;\n  height: 14px;\n  cursor: se-resize;\n}\n\n/* Subtle corner indicator for SE resize */\n.support-chat__resize-handle--se::after {\n  content: '';\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n  width: 6px;\n  height: 6px;\n  border-right: 1.5px solid var(--color-text-secondary);\n  border-bottom: 1.5px solid var(--color-text-secondary);\n  opacity: 0.35;\n  border-radius: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
